import angular from 'angular';

(function() {
    'use strict';

    var orderDetailTabs = {
        templateUrl: require('./order-detail-tabs.html'),
        bindings: {
            order: '<', // Commande
            guid: '<' // Guid de la commande. Utile si on entre directement un guid dans l'url
        },
        controller: OrderDetailTabsController
    };

    OrderDetailTabsController.$inject = ['logger', 'OrdersSvc', 'DOCUMENT_FILTER_CONST'];

    function OrderDetailTabsController(logger, OrdersSvc, DOCUMENT_FILTER_CONST) {
        var vm = this;
        vm.invoiceAssociatedTitle = 'kiss_order.loading_invoices';

        vm.$onInit = function() {
            if (vm.order) {
                loadInvoicesAssociated();
            } else if (vm.guid) {
                loadOrderByGuid();
            }
        };

        /**
         * Charge une commande à partir d'un guid
         */
        function loadOrderByGuid() {
            var options = [DOCUMENT_FILTER_CONST.option.sellerInfo, DOCUMENT_FILTER_CONST.option.buyerInfo];

            OrdersSvc.searchOrderByGuid(vm.guid, options).then(
                function(data) {
                    if (data.content.length > 0) {
                        vm.order = data.content[0];
                        loadInvoicesAssociated();
                    } else {
                        logger.error('kiss_order.unknown');
                    }
                },
                function(/*error*/) {
                    logger.error('error.generic');
                }
            );
        }

        /**
         * Charge les factures associées à la commande.
         */
        function loadInvoicesAssociated() {
            OrdersSvc.getInvoicesAssociated(vm.order.guid).then(
                function(data) {
                    vm.invoicesAssociatedLoaded = true;
                    if (data.length > 0) {
                        vm.invoiceAssociatedTitle = 'commons.invoices';
                        vm.invoices = data;
                    } else {
                        vm.invoiceAssociatedTitle = 'kiss_order.no_invoices';
                    }
                },
                function(/*error*/) {
                    logger.error('error.generic');
                }
            );
        }
    }

    angular.module('app.kissorder').component('orderDetailTabs', orderDetailTabs);
})();
